<template>
<div v-if="margin" style="text-align: center;" :style="{ 'marginLeft': margin }">
  <iframe
    :src="`https://widgets.dviewcontent.com/CountDown/index.html?time=${countDown}&theme=${theme}`" 
    frameborder="0"
    seamless="seamless"
    scrolling="no"
    :width="diff > 100 ? 196 : 180"
  />
</div>
</template>
<script>
  import tinycolor from 'tinycolor2'
  export default {
    props: {
      countDown: {
        type: String,
        required: true
      },
      bgcolor: {
        type: String,
        require: false,
        default: '#FFFFFF'
      }
    },
    data () {
      return  {
        margin : null,
        theme: tinycolor(this.bgcolor).isLight() ? 'dark' : 'light'
      }
    },
    computed: {
      diff () {
        var diff = new Date(this.countDown) - new Date()
        return diff/1000/60/60/24
      },
    },
    mounted() {
      var diff = new Date(this.countDown) - new Date()
      var diffInHours = diff/1000/60/60
      this.margin = diffInHours < 2376 ? '13px' : '0px'
    }
  }
</script>
